// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-detail/components/order-claims/transaction-details/transaction-details.less
// module id = 3758
// module chunks = 0